import { pick } from 'lodash-es'
import { mapActions, mapGetters } from 'vuex'
import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'
import AIMEOS_GETTERS from '@/js/plugins/store/modules/aimeos/getter-types'
import APP_GETTERS from '@/js/plugins/store/modules/app/getter-types.js'
import AIMEOS_ACTIONS from '@/js/plugins/store/modules/aimeos/actions/actions-types.js'
import { getUsermanagementApi } from '@/js/components/Usermanagement/usermanagement-api.js'

export default {
  data() {
    return {
      requestPending: false,
      saveUserError: {},
      currentUser: {},
    }
  },
  computed: {
    ...mapGetters(STOREMODULES.APP, {
      usermanagementUrl: APP_GETTERS.USERMANAGEMENT_URL,
      username: APP_GETTERS.USERNAME,
    }),
    ...mapGetters(STOREMODULES.AIMEOS, {
      addresses: AIMEOS_GETTERS.CUSTOMER_ADDRESSES,
      // deliveryAddresses: AIMEOS_GETTERS.CUSTOMER_DELIVERY_ADDRESSES_FORMATTED,
      // paymentAddress: AIMEOS_GETTERS.CUSTOMER_PAYMENT_ADDRESS,
      // deliveryAddressesFull: AIMEOS_GETTERS.CUSTOMER_DELIVERY_ADDRESSES,
      subUserType: 'CUSTOMER_SUB_USER_TYPE',
      defaultAddressId: 'CUSTOMER_DEFAULT_ADDRESS_ID',
      userFormData: 'CUSTOMER_USER_FORM_DATA',
      optionsPromise: AIMEOS_GETTERS.OPTIONS_PROMISE,
      customerPromise: AIMEOS_GETTERS.CUSTOMER_PROMISE,
    }),
    paymentAddressId() {
      return this.addresses.find(adr => adr.type === 'payment')?.address_id || ''
    },
  },
  async created() {
    this.usermanagementApi = getUsermanagementApi(this.usermanagementUrl)
    // await Promise.all([this.optionsPromise, this.customerPromise])
    // this.setInitialDealerInfos()
  },
  methods: {
    ...mapActions(STOREMODULES.AIMEOS, {
      getCustomer: AIMEOS_ACTIONS.GET_CUSTOMER,
    }),
    setInitialDealerInfos() {
      this.currentUser = {
        name: this.username,
        sub_user_type: this.subUserType,
        additional_data: { ...pick(this.userFormData, ['reference', 'openings']) },
        data: {
          addressId: this.userFormData.contactAddress || this.paymentAddressId,
          firstName: this.userFormData.firstname || '',
          lastName: this.userFormData.lastname || '',
          ...pick(this.userFormData, [
            'telephone',
            'mobile',
            'commercialAllowance',
            'department',
            'partnerFunction',
          ]),
        },
        ...pick(this.userFormData, ['email']),
        selected_address: Array.isArray(this.defaultAddressId) ? '' : this.defaultAddressId,
      }
    },
    async saveSelf(userData) {
      console.log(userData)
      this.requestPending = true

      const selfUpdate = await this.usermanagementApi.saveSelf(userData)
      console.log('🚀 ~ file: my-data-mixin.js:83 ~ saveSelf ~ selfUpdate:', selfUpdate)
      // TODO: SSO usermanagement result prüfen
      if (selfUpdate?.errors) {
        this.saveUserError = selfUpdate.errors
        this.requestPending = false
        return false
      }

      const dpSelfUpdate = await this.usermanagementApi.updateDpSelf()
      // TODO: SSO usermanagement result prüfen
      if (!dpSelfUpdate?.data?.success) {
        this.requestPending = false
        return false
      }
      await this.getCustomer(true)
      this.setInitialDealerInfos()
      this.requestPending = false
      this.editDialog = false
      return true
    },
    async updateSelf() {
      this.requestPending = true
      const dpSelfUpdate = await this.usermanagementApi.updateDpSelf()
      // TODO: SSO usermanagement result prüfen
      if (!dpSelfUpdate?.data?.success) {
        this.requestPending = false
        return
      }
      await this.getCustomer(true)
      this.setInitialDealerInfos()
      this.requestPending = false
    },
  },
}
